import React from "react";
import ArrowExternal from "../../images/arrow-external.png";

// events

// in all the tags html embebed can be used

// date: date format MM/DD/YYYY,
// title: card title,
// description: {
//   info: main info of the card,
//   location: location of the event,
// },
// detailedDate: date in letters if it is needed
// eventLink: in case that the event has a link to redirect
// eventLinkDescription: link description for the url,


const events = [
  {
    date: "6/22/2024",
    title: `Press Play on Knowing Your HIV Status: Orlando, FL`,
    description: {
      info: `Gilead is proud to sponsor this National HIV Testing Day event. Free HIV testing will be offered by local community organizations as well as live entertainment, giveaways, and vendors.`,
      location: `
        Consulado de México 
        <span class="d-block">2550 Technology Drive </span>
        <span class="d-block">Orlando, FL 32804 </span>
      `,
    },
    detailedDate: "June 22, 10 <small>AM</small> - 2:30 <small>PM</small> ET",
  },
  {
    date: "6/22/2024",
    title: `Press Play on Knowing Your HIV Status: Fort Lauderdale, FL`,
    description: {
      info: `Gilead is proud to sponsor this National HIV Testing Day event. Free HIV testing will be offered by local community organizations as well as live entertainment, giveaways, and vendors.`,
      location: `
        Old Dillard Museum 
        <span class="d-block">1009 NW 4th Street </span>
        <span class="d-block">Fort Lauderdale, FL 33311 </span>
      `,
    },
    detailedDate: `June 22, 10 <small>AM</small> - 3 <small>PM</small> ET`,
  },
  {
    date: "6/25/2024",
    title: `Press Play on Knowing Your HIV Status: Dallas, TX `,
    description: {
      info: `Gilead is proud to sponsor this National HIV Testing Day event. Free HIV testing will be offered by local community organizations as well as live entertainment, giveaways, and vendors. `,
      location: `
        Resource Center 
        <span class="d-block">5750 Cedar Springs Road </span>
        <span class="d-block">Dallas, TX 75235 </span>
      `,
    },
    detailedDate: "June 25, 4 <small>PM</small> - 8 <small>PM</small> CT",
  },
  {
    date: "6/25/2024",
    title: `Press Play on Knowing Your HIV Status: New York City, NY `,
    description: {
      info: `Gilead is proud to sponsor this National HIV Testing Day event. Free HIV testing will be offered by local community organizations as well as live entertainment, giveaways, and vendors. `,
      location: `
        Union Square Park 
      `,
    },
    detailedDate: "June 25, 3 <small>PM</small> - 6 <small>PM</small> ET",
  },
  {
    date: "6/27/2024",
    title: `Press Play on Knowing Your HIV Status: Memphis, TN `,
    description: {
      info: `Gilead is proud to sponsor this National HIV Testing Day event. Free HIV testing will be offered by local community organizations as well as live entertainment, giveaways, and vendors. `,
      location: `
        Shelby County Department of Health Headquarters 
        <span class="d-block">814 Jefferson Ave. </span>
        <span class="d-block">Memphis, TN 38105 </span>
      `,
    },
    detailedDate: `June 27, 10 <small>AM</small> - 2 <small>PM</small> CT`,
  },
  {
    date: "6/29/2024",
    title: `Press Play on Knowing Your HIV Status: Atlanta, GA `,
    description: {
      info: `Gilead is proud to sponsor this National HIV Testing Day event. Free HIV testing will be offered by local community organizations as well as live entertainment, giveaways, and vendors. `,
      location: `
        2672 Godby Road 
        <span class="d-block">College Park, GA 30349 </span>
      `,
    },
    detailedDate: `June 29, 12 <small>PM</small> - 8 <small>PM</small> ET`,
  },
  {
    date: "6/29/2024",
    title: `Press Play on Knowing Your HIV Status: Los Angeles, CA `,
    description: {
      info: `Gilead is proud to sponsor this National HIV Testing Day event. Free HIV testing will be offered by local community organizations as well as live entertainment, giveaways, and vendors. "`,
      location: `
        Club Chico 
        <span class="d-block">2915 W. Beverly Blvd </span>
        <span class="d-block">Montebello, CA 90640 </span>
      `,
    },
    detailedDate: `June 29, 6 <small>PM</small> - 10 <small>PM</small> PT`,
  },
  {
    date: "7/23/2024",
    title: `The 52nd Annual National Black Nurses Association, Inc (NBNA) Institute & Conference `,
    description: {
      info: `Join us at the 2024 NBNA Conference designed to equip attendees with the requisite knowledge needed to address <span className="no-break">cross-cutting</span> issues affecting nursing, health care, and health equity. This year's theme is "Advancing Health Care Across the Lifespan: Through <span className="no-break">Re-Imagining</span> Nursing and Human Caring."`,
    },
    eventLink: "https://www.nbna.org/conf",
    eventLinkDescription: "Learn More",
  },
  {
    date: "8/3/2024",
    title: `National Medical Association (NMA) 2024 Annual Convention & Scientific Assembly `,
    description: {
      info: `Join more than 2,500 leading African American physicians, physician executives, health professionals, academicians, and scientists in over 26 specialties from across the country at the NMA 2024 Annual Convention & Scientific Assembly.`,
    },
    eventLink: "https://convention.nmanet.org/",
    eventLinkDescription: "Learn More",
  },
  {
    date: "9/12/2024",
    title: `2024 USCHA `,
    description: {
      info: `Join us at the 2024 US Conference on HIV/AIDS (USCHA), the premier HIV conference and largest <span className="no-break">HIV-related</span> gathering in the United States. `,
    },
    eventLink: "https://uscha.life/register/",
    eventLinkDescription: "Register Now",
  },
  {
    date: "11/14/2024",
    title: `ANAC2024 Conference `,
    description: {
      info: `We're excited to join nurses and AHCPs who work in HIV care at the Association of Nurses in AIDS Care (ANAC) Conference. `,
    },
    eventLink:
      "https://www.nursesinaidscare.org/i4a/pages/index.cfm?pageID=4623",
    eventLinkDescription: "Learn More",
  },
];

const eventList = [
  ...events.sort((a, b) => new Date(a.date) - new Date(b.date)),
];


export const EventCard = ({ event }) => {
  return (
    <>
      <span className="date">{event.date}</span>
      <span
        className="title"
        dangerouslySetInnerHTML={{ __html: event.title }}
      ></span>
      <span className="description">
        <span
          dangerouslySetInnerHTML={{ __html: event.description.info }}
        ></span>
        {event.description.location && (
          <span
            className="d-block py-3"
            dangerouslySetInnerHTML={{ __html: event.description.location }}
          ></span>
        )}
        {event.detailedDate && (
          <span dangerouslySetInnerHTML={{ __html: event.detailedDate }}></span>
        )}
      </span>
    </>
  );
};

export const Event = ({ event }) => {
  return (
    event.eventLink ?
      <>
        <a href={event.eventLink} target="_blank">
          <EventCard event={event}/>
          <span className="register">
            {event.eventLinkDescription} <img src={ArrowExternal} alt=""/>
          </span>
        </a>
      </>
    : <EventCard event={event}/>
  );
};

export default eventList;
